export const SET_ADMINS_DATA = 'SET_ADMINS_DATA'
export const UPDATE_ADMINS = 'UPDATE_ADMINS'

export const setAdminsData = payload => dispatch =>
  dispatch({
    type: SET_ADMINS_DATA,
    payload: payload
  })
export const updateAdmins = () => dispatch =>
  dispatch({
    type: UPDATE_ADMINS
  })
